import { useQuery } from "@apollo/client";
import { GET_CONVENIENCES } from "..";
import { Conveniences } from "../types";

export function useGetConveniences() {
  const { data: conveniencesList } = useQuery<Conveniences>(GET_CONVENIENCES);

  return { conveniencesList };
}
